import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#595B61"
      d="M14.707 14.707a1 1 0 0 1-1.414 0l-2.387-2.387a6.25 6.25 0 1 1 1.414-1.414l2.387 2.387a1 1 0 0 1 0 1.414ZM7.25 3a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5Z"
    />
  </svg>
);
export default SvgComponent;
